module.exports = __webpack_public_path__ + "img/id_project.1b779858.png";